import * as Sentry from "@sentry/react";

export function initSentry() {
  Sentry.init({
    dsn: "https://de54b3ec3da4d5f258353fabbcc12d31@fish.aftershoot.co/44",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllInputs: false,
        maskAllText: false,
      }),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
    enabled: !import.meta.env.DEV,
    environment: import.meta.env.MODE,
    sendDefaultPii: true,
  });
}

export const captureSentryException = Sentry.captureException;
export const captureSentryMessage = Sentry.captureMessage;
export const setSentryUser = Sentry.setUser;
export const getSentryCurrentScope = Sentry.getCurrentScope;
